
export default {
    label: "Count",
    callback: (array) => array.length
}


// WEBPACK FOOTER //
// ./src/aggregators/count.js